import React from 'react';
import { Button, Card, Table, TablePaginationConfig } from 'antd';
import Column from 'antd/lib/table/Column';
import { ActionHistoryElementResponse } from '@openapi';
import api from '@services/api';

import styles from './styles.module.scss';
import { CSVLink } from 'react-csv';

const ActionHistory = () => {
  const [actions, setActions] = React.useState<ActionHistoryElementResponse[]>();
  const [pagination, setPagination] = React.useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    total: actions?.length,
  });

  React.useEffect(() => {
    api.actionHistory.getActionHistory().then((data) => {
      setActions(data.elements);
    });
  }, []);

  const apiCount = (pagination.pageSize || 0) * (pagination.current || 0);
  const apiItem = (apiCount || 0) - ((pagination.pageSize || 0) - 1);

  return (
    <Card
      title={`Action History: ${apiItem}-${apiCount} / ${actions?.length}`}
      extra={
        <CSVLink data={actions || []} filename="actionHistory.csv" target="_blank">
          <Button type="primary">CSV</Button>
        </CSVLink>
      }
      bodyStyle={{ padding: 0 }}
    >
      <Table
        dataSource={actions}
        onRow={(record: ActionHistoryElementResponse) => ({ className: styles[record.status] })}
        rowKey={(record: ActionHistoryElementResponse) => record.id as string}
      >
        <Column title="Date" dataIndex="createdAt" render={(date: Date | null) => date?.toLocaleString()} />
        <Column title="User" dataIndex="userEmail" />
        <Column title="Action" dataIndex="action" />
        <Column title="Element" dataIndex="element" />
        <Column title="Status" dataIndex="status" />
        <Column title="More information" dataIndex="complementaryInformation" />
      </Table>
    </Card>
  );
};

export default React.memo(ActionHistory);
